<template>
  <div>
    <NavBar />
    <About :eventName="$route.params.eventName" />
    <Footer />
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";
import About from "./components/About.vue";

export default {
  name: "AgendaPage",
  components: {
    NavBar,
    Footer,
    About
  }

};
</script>

<style scoped>
@import "./components/webflow.css";
@import "./components/normalize.css";
@import "./components/sffnotes.webflow.css";
</style>
